import useApi from '../../hooks/api/useApi';

export function useGetPlans() {
  const { data, error, isLoading, refresh } = useApi('/plans', {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    plans: data?.data?.plans || [],
    current: data?.data?.current || null,
    success: data?.success ?? false,
    error,
    isLoading,
    refresh
  };
}
